import React from 'react';
import InstitucionalFrame from './InstitucionalFrame';

const InstitucionalLocacao: React.FC = () => (
  <InstitucionalFrame page="locacao.html" title="Locação de Quadras" />
);

export default InstitucionalLocacao;
